export default __webpack_public_path__ + "static/media/headere.7ad32696.jpg";